<template>
  <ob-admin-section
    type="orase"
    :xlsx="false"
    :confirm-value="false"
    @confirmed="_cbConfirmed"
    :extension="true"
    :extensionactions="false"
    :dialogs="false"
    @itemsSelected="_cbItemsSelected">
    <template slot="section-title">Sectiune Orase</template>
    <template slot="toolbar-title">Baza de date Orase</template>

    <template slot="fab">
      <v-speed-dial
        class="ob-speed-dial"
        v-model="fab"
        absolute
        fixed
        bottom
        right
        direction="top"
        open-on-hover
        transition="scroll-y-reverse-transition"
        key="speeddial">
        <v-btn
          slot="activator"
          v-model="fab"
          color="accent"
          dark
          fab
          key="speed">
          <v-icon>mdi-menu</v-icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-tooltip left>
          <span slot="activator">
            <v-btn
              fab
              small
              color="primary darken-3"
              :disabled="!!items.length"
              @click="_cbComputeAllPerioada">
              <v-icon>mdi-function</v-icon>
            </v-btn>
          </span>
          <span>Calculeaza TOATE DATELE pentru TOATE elementele din perioada selectata</span>
        </v-tooltip>

        <v-tooltip left>
          <span slot="activator">
            <v-btn
              fab
              small
              color="primary"
              :disabled="!items.length"
              @click="_cbCompute">
              <v-icon>mdi-function-variant</v-icon>
            </v-btn>
          </span>
          <span>Calculeaza TOATE DATELE pentru elementele selectate ({{items.length}})</span>
        </v-tooltip>

        <v-tooltip left>
          <span slot="activator">
            <v-btn
              fab
              small
              color="primary"
              :disabled="!items.length"
              @click="_cbComputeIndicatori">
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </span>
          <span>Calculeaza INDICATORII pentru elementele selectate ({{items.length}})</span>
        </v-tooltip>
      </v-speed-dial>
    </template>

     <template slot="ob-row-expansion" slot-scope="{_id, cifop, cifos, denumire, judet}">
      <ob-verificare-apl :_id="_id" :perioada="tabs[selectedTab].label" :cifop="cifop" :cifos="cifos" :denumire="denumire" :judet="judet">
      </ob-verificare-apl>
    </template>
  </ob-admin-section>
</template>

<script>
import AdminSection from '@/components/AdminSection'
import Dialog from '@/components/Dialog'
import VerificareApl from '@/components/VerificareApl'

export default {
  name: 'orase',
  components: {
    'ob-admin-section': AdminSection,
    'ob-dialog': Dialog,
    'ob-verificare-apl': VerificareApl
  },
  data: () => ({
    type: 'orase',
    items: [],
    fab: null
  }),
  computed: {
    tabs () {
      return this.$store.getters[`${this.type}/tabs`]
    },
    selectedTab () {
      return this.$store.getters[`${this.type}/selectedTab`]
    },
    selectedTabID () {
      return this.$store.getters[`${this.type}/selectedTabID`]
    },
    latestPerioada () {
      return this.$store.getters[`${this.type}/latestPerioada`]
    }
  },
  methods: {
    _cbConfirmed (value) {
    },
    _cbComputeAllPerioada () {
      this.$store.dispatch('recomputeAllPerioada', { type: this.type, idPerioada: this.selectedTabID })
    },
    _cbCompute () {
      if (this.items.length) {
        this.$store.dispatch(`${this.type}/compute`, { type: 'compute', items: this.items })
      }
    },
    _cbComputeIndicatori () {
      if (this.items.length) {
        this.$store.dispatch(`${this.type}/compute`, { type: 'indicatori', items: this.items })
      }
    },
    _cbItemsSelected (items) {
      this.items = [...items]
    }
  },
  created () {
    this.$store.dispatch('orase/setEventWatchers')
    this.$store.dispatch('orase/fetchTabs')
    this.$store.dispatch('orase/fetchHeaders')
    this.$store.dispatch('orase/fetchItems')
  }
}
</script>

<style>

</style>
